import { classnames } from '@aibees/shared/utils';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { InternalLinkButtonProps as Props } from './types';

export const InternalLinkButton = memo(
  ({ className, to, target, children, fullWidth = true, sx }: Props) => {
    if (!to) return children;

    return (
      <Styled.Wrapper
        className={classnames('InternalLinkButton', className)}
        to={to}
        target={target || '_blank'}
        fullWidth={fullWidth}
        sx={mergeSx(SX.root, sx)}
      >
        {children}
      </Styled.Wrapper>
    );
  }
);

InternalLinkButton.displayName = 'InternalLinkButton';
